import Vue from 'vue'
import Vuex from 'vuex'
import storage from "../fetch/storage";
import i18n from "@/i18n"
import {getConfigInfo} from "@/fetch/configApi";
Vue.use(Vuex)
let loading = false
const store = new Vuex.Store({
    state: {
        themeName: "custom",
        themeStyle: {
            "custom": ``,
            "default": `
			--nav-bg:#4D648D;
			--nav-color:#ffffff;
			--nav-hover-bg:rgba(77, 100, 141,.9);
			--nav-bg-hover-border:#C0C4CC;
			--dt-primary:#00d4ff;
			--dt-primary-hover:#0099cc;
			--dt-bg:#1e3c72;
		`,
        },
        activeMenu: storage.get('activeMenu'),
        initRegisteredLogin: false,
        menus: [],
        permissions: [],
        tenantId: '',
        redirectPath:'/yssz/login',
        isBt:false,
        isLt:false,
        isDt:false,
        tenantKey:'',
        tenantInfo:storage.get('tenantInfo') || {
            homeLogoImage:'',
            homeName:'',
            homeLogoConfig:'',
        },
        waveTimestamp:''
    },
    getters: {
        theme(state) {
            const storageColor = storage.get('bg')
            let color = 'rgb(77, 100, 141)'
            if (storageColor) {
                color = storageColor
            } else {
                storage.set('bg', color)
            }
            state.themeStyle[state.themeName] = `
			--nav-bg:${color};
			--nav-color:#ffffff;
			--layout-bg:#00713A;
			--layout-header:#007E3A;
			--layout-color:#FFFFFF;
			--layout-menu-hover:#35a568;
			--nav-hover-bg:rgba(77, 100, 141,.9);
			--nav-bg-hover-border:#C0C4CC;
			--dt-primary:#00d4ff;
			--dt-primary-hover:#0099cc;
			--dt-bg:rgba(30,60,114,1);
		`
            return state.themeStyle[state.themeName]
        },
        viewMenus: (state) => {
            return state.menus.filter(item => {
                if (item.children) {
                    item.children = item.children.filter(v => !v.meta?.hidden)
                }
                return !item.meta?.hidden
            })
        }
    },
    actions: {
        async fetchTenantInfo({ commit }) {
            if(loading) return
            loading = true
            try {
                const res = await getConfigInfo();
                const data = res.data;
                commit('updateTenantInfo', data);
            }finally{
                loading = false
            }
        }
    },
    mutations: {
        updateTenantInfo(state, data) {
            state.tenantInfo = data;
            storage.set('tenantInfo', state.tenantInfo);
            this.commit('applyTenantFlags');
        },
        applyTenantFlags(state) {
            switch (state.tenantInfo.mark) {
                case 'vibration-monitoring':
                    state.isDt = true;
                    break;
                case 'littlefuse':
                    state.isLt = true;
                    localStorage.setItem('language', 'zh_CN');
                    i18n.locale = 'zh_CN';
                    break;
                case 'phm':
                    state.isBt = true;
                    break;
            }
        },
        updateActiveMenu(state, activeMenu) {
            state.activeMenu = activeMenu
        },
        setTheme(state, themeName) {
            state.themeName = themeName
        },
        setColor(state, color) {
            state.themeStyle.custom = `--nav-bg:${color};`
        },
        setInitRegisteredLogin(state, initRegisteredLogin) {
            state.initRegisteredLogin = initRegisteredLogin
        },
        setTenantKey(state,tenantKey){
            state.tenantKey = tenantKey
        },
        setTenantId(state, tenantId) {
            state.tenantId = tenantId
        },
        setStateValue(state, item) {
            state[item.key] = item.value
        }
    },
})

export default store
